import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-26">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left text-gray-700 hover:text-[#1e4d7b] transition-colors" data-id="element-27">
        <span className="font-medium text-sm" data-id="element-28">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-29">
          <ChevronDown className="h-4 w-4" data-id="element-30" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-31">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-32">
            <div className="pb-4 text-xs text-gray-500 leading-relaxed" data-id="element-33">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function LegalAccordion() {
  const [openItem, setOpenItem] = useState<string | null>(null);
  const toggleItem = (item: string) => {
    setOpenItem(openItem === item ? null : item);
  };
  return <div className="max-w-2xl mx-auto mt-8 border border-gray-200 rounded-lg bg-white" data-id="element-34">
      <AccordionItem title="Política de Privacidad" isOpen={openItem === 'privacy'} onToggle={() => toggleItem('privacy')} data-id="element-35">
        <p className="mb-3" data-id="element-36">
          <strong data-id="element-37">1. Responsable del tratamiento:</strong> El responsable del
          tratamiento de tus datos personales es Hogar Blindado. Puedes
          contactarnos a través del correo electrónico proporcionado en la
          página de compra.
        </p>
        <p className="mb-3" data-id="element-38">
          <strong data-id="element-39">2. Datos que recopilamos:</strong> Recopilamos únicamente los
          datos necesarios para procesar tu compra: nombre, dirección de correo
          electrónico y datos de pago (procesados de forma segura por Hotmart).
        </p>
        <p className="mb-3" data-id="element-40">
          <strong data-id="element-41">3. Finalidad del tratamiento:</strong> Tus datos se utilizan
          exclusivamente para: gestionar tu compra, enviarte el acceso al
          producto digital, y comunicaciones relacionadas con tu compra.
        </p>
        <p className="mb-3" data-id="element-42">
          <strong data-id="element-43">4. Base legal:</strong> El tratamiento de tus datos se basa en
          la ejecución del contrato de compra y tu consentimiento expreso.
        </p>
        <p className="mb-3" data-id="element-44">
          <strong data-id="element-45">5. Conservación de datos:</strong> Tus datos se conservarán
          mientras sea necesario para cumplir con las obligaciones legales y
          contractuales.
        </p>
        <p className="mb-3" data-id="element-46">
          <strong data-id="element-47">6. Derechos:</strong> Tienes derecho a acceder, rectificar,
          suprimir, limitar el tratamiento, portabilidad y oposición. Puedes
          ejercer estos derechos contactándonos por correo electrónico.
        </p>
        <p data-id="element-48">
          <strong data-id="element-49">7. Seguridad:</strong> Implementamos medidas técnicas y
          organizativas para proteger tus datos personales contra acceso no
          autorizado, pérdida o destrucción.
        </p>
      </AccordionItem>

      <AccordionItem title="Términos y Condiciones" isOpen={openItem === 'terms'} onToggle={() => toggleItem('terms')} data-id="element-50">
        <p className="mb-3" data-id="element-51">
          <strong data-id="element-52">1. Objeto:</strong> Estos términos regulan la compra y uso del
          producto digital "Hogar Blindado", que incluye e-book, audioguía y
          calendario de 14 días.
        </p>
        <p className="mb-3" data-id="element-53">
          <strong data-id="element-54">2. Producto digital:</strong> Al completar la compra,
          recibirás acceso inmediato al contenido digital. Este es un producto
          de información y educación, no un servicio médico.
        </p>
        <p className="mb-3" data-id="element-55">
          <strong data-id="element-56">3. Precio y pago:</strong> El precio indicado incluye todos
          los impuestos aplicables. El pago se procesa de forma segura a través
          de la plataforma Hotmart.
        </p>
        <p className="mb-3" data-id="element-57">
          <strong data-id="element-58">4. Acceso al producto:</strong> Una vez confirmado el pago,
          recibirás un correo electrónico con las instrucciones de acceso. El
          acceso es personal e intransferible.
        </p>
        <p className="mb-3" data-id="element-59">
          <strong data-id="element-60">5. Propiedad intelectual:</strong> Todo el contenido del
          producto está protegido por derechos de autor. Queda prohibida su
          reproducción, distribución o modificación sin autorización expresa.
        </p>
        <p className="mb-3" data-id="element-61">
          <strong data-id="element-62">6. Garantía:</strong> Ofrecemos garantía de satisfacción según
          las políticas de Hotmart. Si no estás satisfecho, puedes solicitar el
          reembolso dentro del plazo establecido.
        </p>
        <p className="mb-3" data-id="element-63">
          <strong data-id="element-64">7. Limitación de responsabilidad:</strong> Este producto
          ofrece información educativa sobre métodos naturales. No sustituye el
          consejo médico profesional. Los resultados pueden variar según cada
          caso.
        </p>
        <p data-id="element-65">
          <strong data-id="element-66">8. Legislación aplicable:</strong> Estos términos se rigen por
          la legislación española. Para cualquier controversia, las partes se
          someten a los juzgados y tribunales competentes.
        </p>
      </AccordionItem>
    </div>;
}